import { Trans } from 'react-i18next';
import styled from 'styled-components';

import { StrongText } from '@dreryk/react-components';

import { entitlementStatementsTranslationKeys } from '../../../translations';

const StyledDescriptionWrapper = styled.div`
   display: inline-block;
`;

export const ConfirmationModalContent = (): JSX.Element => {
   return (
      <StyledDescriptionWrapper>
         <Trans
            i18nKey={entitlementStatementsTranslationKeys.confirmationModal.description}
            components={{ bold: <StrongText testId={'printQuestion'} /> }}
         />
      </StyledDescriptionWrapper>
   );
};
